import React from "react";

import { Props } from "./types";

function ToggleArrow({ className, style }: Props) {
  return (
    <svg
      className={className}
      style={style}
      id="icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9.594 6.195"
    >
      <path
        d="M5.3,10.945,9.38,15.021a.716.716,0,0,1,0,1.016l-.677.677a.716.716,0,0,1-1.016,0L4.794,13.828,1.9,16.718a.716.716,0,0,1-1.016,0l-.68-.677a.716.716,0,0,1,0-1.016l4.076-4.076A.717.717,0,0,1,5.3,10.945Z"
        transform="translate(0.004 -10.734)"
      />
    </svg>
  );
}

export { ToggleArrow };
